export const isResponseArrayValid = (response: any): boolean => {
    return response !== null && response !== undefined && Array.isArray(response);
};
